import create from "zustand";

export enum MerchandiseOrderViewMode {
    PER_ORDER = "per_order",
    PER_ITEM = "per_item",
}

export enum MerchandiseDashboardFulfillmentFilter {
    ALL = "all",
    FULFILLED = "fulfilled",
    UNFULFILLED = "pending_fulfillment",
    PARTIALLY_FULFILLED = "partially_fulfilled",
}

export interface MerchandiseFilter {
    all: boolean;
    selected: ID[];
}

interface MerchandiseDashboardFilters {
    merchandise: MerchandiseFilter;
    fulfillmentStatus: MerchandiseFilter;
}

interface MerchandiseDashboardState {
    filters: MerchandiseDashboardFilters;
    viewMode: MerchandiseOrderViewMode;
    searchQuery: string;
    selectedOrderId: ID | null;
    isLoading: boolean;

    actions: {
        setFilters: (filters: Partial<MerchandiseDashboardFilters>) => void;
        setViewMode: (mode: MerchandiseOrderViewMode) => void;
        setSearchQuery: (query: string) => void;
        setSelectedOrderId: (orderId: ID | null) => void;
        setIsLoading: (isLoading: boolean) => void;
        resetFilters: () => void;
    };
}

const initialFilters: MerchandiseDashboardFilters = {
    merchandise: { all: true, selected: [] },
    fulfillmentStatus: { all: true, selected: [] },
};

export const useMerchandiseDashboardStore = create<MerchandiseDashboardState>((set) => ({
    filters: initialFilters,
    viewMode: MerchandiseOrderViewMode.PER_ORDER,
    searchQuery: "",
    selectedOrderId: null,
    isLoading: false,

    actions: {
        setFilters: (filters) =>
            set((state) => ({
                filters: { ...state.filters, ...filters },
            })),
        setViewMode: (viewMode) => set({ viewMode }),
        setSearchQuery: (searchQuery) => set({ searchQuery }),
        setSelectedOrderId: (selectedOrderId) => set({ selectedOrderId }),
        setIsLoading: (isLoading) => set({ isLoading }),
        resetFilters: () => set({ filters: initialFilters }),
    },
}));
